import { cn } from '@/lib/utils'

interface LogoProps {
  variant?: 'full' | 'mark'
  className?: string
  size?: string
}

export function Logo({ variant = 'full', className, size }: LogoProps) {
  // Default sizes. Override with size prop for specific pages.
  const sizeClass = size ?? (variant === 'mark' ? 'h-10' : 'h-10 sm:h-12')

  return (
    <>
      {/* Light mode: dark logo */}
      <img
        src="/logo-full-dark.png"
        alt="TapReply"
        className={cn(sizeClass, 'w-auto dark:hidden', className)}
      />
      {/* Dark mode: white logo */}
      <img
        src="/logo-full.png"
        alt="TapReply"
        className={cn(sizeClass, 'w-auto hidden dark:block', className)}
      />
    </>
  )
}
